import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const thirdPartyNudgeEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() => import(/* webpackChunkName: "async-third-party-nudge-spotlight" */ './main'),
	),
	getPreloadProps: () => ({}),
});
